<template>
  <div>
    <b-modal
      v-model="showModalInternal"
      id="category-details-form-modal"
      scrollable
      :title="title"
      title-class="font-18"
      size="lg"
      style="z-index:100100!important;"
      hide-footer
    >
      <div class="row">
        <CategoryForm :initialCategoryData="initialCategoryData" @onSave="onSave"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {BModal} from 'bootstrap-vue-next'
import CategoryForm from '@/views/DrugstoreCommonManager/CategoryForm.vue'

export default defineComponent({
  name: 'CategoryFormModal',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ()=>'Szczegóły kategorii'
    },
    initialCategoryData: {
      type: Object,
      required: false
    }
  },
  emits: ['update:showModal','onSave','onClose'],
  components: {CategoryForm, BModal},
  data(){
    return {
      showModalInternal: this.showModal
    }
  },
  methods:{
    onSave(payload){
      this.showModalInternal = false
      this.$emit('onSave', payload)
    },
    closeModal(){
      this.showModalInternal = false
      this.$emit('onClose')
    }
  },
  watch:{
    showModal(newVal){
      this.showModalInternal = newVal
    },
    showModalInternal(newVal){
      this.$emit('update:showModal', newVal)
    }
  }
})
</script>
<style scoped>
</style>
